// Main entry point for the application
import '../styles.css';
import './app.js';
